import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BuyerInfoCreateComponent } from './buyer-info-create/buyer-info-create.component';
import { BuyerInfoEditComponent } from './buyer-info-edit/buyer-info-edit.component';
import { BuyerInfoUnlinkComponent } from './buyer-info-unlink/buyer-info-unlink.component';
import { HttpService } from '../../../../../../core';
import { ActivatedRoute, Router } from '@angular/router';

// import {Contants} fro


@Component({
  selector: 'app-buyer-info',
  templateUrl: './buyer-info.component.html',
  styleUrls: ['./buyer-info.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})

export class BuyerInfoComponent implements OnInit {
  @Input() property: any;
  @Input() project: any;

  projectId: any;

  constructor(private cdr: ChangeDetectorRef, private dialog: MatDialog, private route: ActivatedRoute, private router: Router, private httpService: HttpService) {
  }

  ngOnInit(): void {
    console.log(this.property);
    if (!this.project) {
      this.projectId = this.route.snapshot.paramMap.get('id');

      this.httpService.getProjectDetailByProjectId(this.projectId).subscribe((res: any) => {
        if (res.code === 1) {
          this.project = res.data;
        } else {
          this.router.navigateByUrl('/projects');
        }
      });
    }
  }


  openCreateBuyerInfoDialog() {
    const dialogRef = this.dialog.open(BuyerInfoCreateComponent, {
      width: '90%',
      maxWidth: '1000px',
      data: { property: this.property },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        if (this.property.buyers) {
          this.property.buyers.push(result.buyer);
          // this.cdr.detectChanges();
        } else {
          this.property.buyers = [];
          this.property.buyers.push(result.buyer);
          // this.cdr.detectChanges();
        }
      }
    });

  }

  openEditBuyerDialog(buyer) {
    const dialogRef = this.dialog.open(BuyerInfoEditComponent, {
      width: '90%',
      maxWidth: '1000px',
      data: { buyer, project: this.project, property: this.property }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        if (result.isPropertyChanged) {
          const oldBuyers = this.property.buyers;
          this.property.buyers = oldBuyers.filter(b => b.id !== buyer.id);
        } else {
          const index = this.property.buyers.findIndex(b => b.id === buyer.id);
          this.property.buyers[index] = result.buyer;
        }
      }
    });
  }

  openUnlinkBuyerDialog(buyer) {
    const dialogRef = this.dialog.open(BuyerInfoUnlinkComponent, {
      width: '90%',
      maxWidth: '500px',
      data: { buyer, property: this.property }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      console.log(buyer);
      if (result && result.code === 1) {
        const oldBuyers = this.property.buyers;
        this.property.buyers = oldBuyers.filter(b => b.id !== buyer.id);

        // this.cdr.detectChanges();
      }
    });
  }
}
